import { render, staticRenderFns } from "./WorkBookPersonalPreferences.vue?vue&type=template&id=21528e4b&scoped=true&"
import script from "./WorkBookPersonalPreferences.vue?vue&type=script&lang=js&"
export * from "./WorkBookPersonalPreferences.vue?vue&type=script&lang=js&"
import style0 from "./WorkBookPersonalPreferences.vue?vue&type=style&index=0&id=21528e4b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21528e4b",
  null
  
)

export default component.exports